define('constants/webSocketSendMessagePriorities',[], function() {
    return {
        high: "high",
        low: "low"
    };
});

